import { Cookies } from '@components/App/Cookies'
import { AppLoader } from '@components/AppMain/AppLoader'
import { Router } from '@components/Router'

import { StoreProvider } from '@/store'

import '@octopus-do/octopus-storybook/styles.css'
import '@octopus-do/octopus-storybook/variables.css'
import '@octopus-do/octopus-editor/dist/index.css'

export const App = () => (
  <StoreProvider>
    <Router />
    <Cookies />
    <AppLoader />
  </StoreProvider>
)
